<template>
    <div @click="loadFavoritesPage" :class="favoritesClasses">
        <div class="favorites-count-container">
            <span>{{ favoritesCount }}</span>
            <img class="favorites-coeur" src="/images/icons/coeur-orange.png" alt="">
        </div>
        <div class="favorites-text">Mes coups de coeur</div>
    </div>
</template>

<script>
  import store from './../store'
  import queryString from 'query-string'

  export default {
    name: 'favorites',
    data () {
      return {
        state: store.state
      }
    },
    computed: {
      favoritesCount () {
        return store.getFavoriteProducts().length
      },
      favoritesClasses () {
        return {
          favorites: true,
          'no-fav': this.favoritesCount === 0
        }
      }
    },
    methods: {
      loadFavoritesPage () {
        if (this.favoritesCount === 0) return
        let query = queryString.stringify({ fav: store.getFavoriteProducts() }, { arrayFormat: 'bracket' })
        window.location.href = '/produits?' + query
      }
    }
  }
</script>
